import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const MPPProjectPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://customer-assets.emergentagent.com/job_precision-vision/artifacts/vi6uxzqt_MPP.jpg)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70" />
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Pump Packaging Project</h1>
          <p className="text-xl max-w-3xl mx-auto">
            3D Modelling Services for Pump Packaging
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Project <span className="text-red-600">Overview</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              The Pump Packaging Project involves comprehensive 3D Modelling Services. Our team delivered detailed 3D model development across all engineering disciplines using PDMS software, ensuring precision and adherence to industry standards.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_precision-vision/artifacts/vi6uxzqt_MPP.jpg"
                alt="MPP Project"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-6">Project Details</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-slate-900">Client</p>
                    <p className="text-slate-600">ADNOC</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-slate-900">Location</p>
                    <p className="text-slate-600">UAE</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-slate-900">Year</p>
                    <p className="text-slate-600">2025-Till Now</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-red-600 rounded-full mt-2" />
                  <div>
                    <p className="font-semibold text-slate-900">Category</p>
                    <p className="text-slate-600">3D Modelling</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">Scope of Services</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                '3D Model Development for all Disciplines in PDMS software',
                '30%, 60%, 90% Review',
                'Tags Clearance',
                'GADs, ISOMETRICS & Layouts, MTO Extraction',
                'Close out'
              ].map((service, index) => (
                <Card key={index} className="border-none shadow-lg">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 text-base">{service}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl font-bold text-slate-900 mb-6">Project Highlights</h3>
            <div className="prose prose-slate max-w-none">
              <p className="text-slate-700 leading-relaxed mb-4">
                The Pump Packaging Project showcases Total Vision's expertise in advanced 3D modelling and engineering services. Our team utilized PDMS (Plant Design Management System) software to develop comprehensive 3D models across all disciplines, ensuring seamless integration and coordination.
              </p>
              <p className="text-slate-700 leading-relaxed mb-4">
                Through multiple review stages (30%, 60%, and 90%), we maintained rigorous quality control and adherence to project specifications. Our deliverables included detailed GADs (General Arrangement Drawings), isometric drawings, layout plans, and accurate Material Take-Off (MTO) extraction.
              </p>
              <p className="text-slate-700 leading-relaxed">
                The project was successfully closed out with complete documentation and handover, demonstrating our commitment to excellence in 3D modelling services for the oil and gas sector.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MPPProjectPage;
